import axios from 'axios';
import { createInstance } from '@datapunt/matomo-tracker-react';
import { getConfig } from '../config/apiConfig';
import { setLocalStorageItem } from '../utils/clientStorage';

/**
 *
 * @param {Boolean} isinSite
 * @returns {MatomoTracker}
 */
const invokeWebAnalytics = async (isinSite) => {
  // Get auth header config
  const config = await getConfig();
  const url = `api/webanalytics/webanalyticsdetails/inSite/${isinSite}`;
  const resp = await axios.get(url, config);
  if (!resp.data) {
    return null;
  }
  if (
    resp.data.webAnalyticIsEnable !== '1' ||
    !resp.data.webAnalyticSiteUrl ||
    !resp.data.webAnalyticSiteID
  ) {
    return null;
  }
  const u = `//${resp.data.webAnalyticSiteUrl}/`;
  setLocalStorageItem('NewVisitID', resp.data.visitId);
  return createInstance({
    urlBase: resp.data.webAnalyticSiteUrl,
    siteId: resp.data.webAnalyticSiteID,
    trackerUrl: `${u}matomo.php`, // optional, default value: `${urlBase}matomo.php`
    srcUrl: `${u}matomo.js` // optional, default value: `${urlBase}matomo.js`
  });
};
export default invokeWebAnalytics;
